const Code = {
  SUCCESS: { statusCode: 0, message: 'success' },
  LOGIN_ERROR: { statusCode: 1005, message: '登录失效,请重新登陆' },
  LOGIN_DUPLICATE: { statusCode: 1114, message: '账户已在其它设备登陆' },
}

export { Code }
